import { Container, Row, Col } from "react-bootstrap";
import colorSharp from "../assets/img/color-sharp.png";

export const Skills = () => {
  // Just add new skills to this list!
  const skillList = [
    "React",
    "JavaScript",
    "TypeScript",

    "Python",
    "Java",
    "SQL",
    "Snowflake",
    "Node.js",
    "HTML/CSS",
    "Power BI",
    "Tailwind CSS",
    "JMP",
    "Git",
    "Agile",
    "C",
    "Haskell",
    "Bash",
  ];

  return (
    <section className="skill" id="skills">
      <Container>
        <Row>
          <Col>
            <div className="skill-bx">
              <h2>Skills</h2>
              <p>
                A collection of technologies and methodologies I’ve mastered
                through university projects, work experience at Sanofi, and
                personal innovation.
              </p>

              <div className="skill-bubble-container">
                {skillList.map((skill, index) => (
                  <div key={index} className="skill-bubble">
                    {skill}
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <img
        src={colorSharp}
        alt="gradient thingy"
        className="background-image-left"
      />
    </section>
  );
};
